import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  players: [],
};

const coachPlayersSlice = createSlice({
  name: "coachPlayers",
  initialState,
  reducers: {
    setPlayers(state, action) {
      state.players = action.payload;
    },
    addPlayer(state, action) {
      if (!state.players) return;
      state.players.push(action.payload);
      state.players.sort((a, b) => a.fullName.localeCompare(b.fullName));
    },
    removePlayer(state, action) {
      if (!state.players) return;
      state.players = state.players.filter(
        (p) => p.user_id !== action.payload.user_id
      );
    },
    clearPlayers(state) {
      state.players = null;
    },
  },
});

export const { setPlayers, addPlayer, removePlayer, clearPlayers } =
  coachPlayersSlice.actions;

export default coachPlayersSlice.reducer;
